import { useState } from "react";
import { useTranslations } from "next-intl";
import { Check, ChevronsDownUp, ChevronsUpDown, Settings } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function HeaderTitle() {
  const t = useTranslations("layout30.workspaceSelector");
  const [open, setOpen] = useState(false);

  return (
    <div className="group flex shrink-0 items-center justify-between gap-2.5">
      <div className="flex items-center gap-2">
        <DropdownMenu open={open} onOpenChange={setOpen}>
          <DropdownMenuTrigger asChild>
            <Button
              variant="ghost"
              aria-label={t("label")}
              className="-ms-0.5 flex items-center justify-between gap-1 px-1.5 hover:bg-accent"
            >
              <span className="hidden text-sm font-medium text-foreground lg:inline">
                {t("current")}
              </span>
              <span className="inline text-sm font-medium text-foreground lg:hidden">
                {t("initial")}
              </span>
              {open ? (
                <ChevronsDownUp className="size-4 text-muted-foreground" />
              ) : (
                <ChevronsUpDown className="size-4 text-muted-foreground" />
              )}
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-64"
            side="bottom"
            align="start"
            sideOffset={7}
            alignOffset={0}
          >
            <DropdownMenuLabel>{t("menuLabel")}</DropdownMenuLabel>
            <DropdownMenuGroup>
              <DropdownMenuItem
                disabled
                className="flex items-center justify-between"
              >
                <div className="flex items-center gap-2">
                  <span className="flex size-5 shrink-0 items-center justify-center rounded-md bg-primary text-xs uppercase text-primary-foreground">
                    {t("initial")}
                  </span>
                  <span className="truncate">{t("current")}</span>
                </div>
                <Check className="size-4 text-primary" />
              </DropdownMenuItem>
            </DropdownMenuGroup>
            <DropdownMenuSeparator />
            <DropdownMenuItem disabled>
              <Settings className="size-4" />
              <span>{t("settingsUnavailable")}</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
}
